import toNumber from 'lodash/toNumber';
/**
 * @params {Object} params
 * @param {number} params.years
 * @param {number} params.months
 * @returns {number}
 */
export const toTotalMonths = ({ months = 0, years = 0 } = {}) =>
  toNumber(years) * 12 + toNumber(months);
